import { NgModule, ModuleWithProviders } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [],
    imports: [
        MatDatepickerModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        MatTableModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatSortModule,
        MatTabsModule,
        MatRadioModule,
        MatCardModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatTooltipModule,
        MatDialogModule,
        TranslateModule
    ],
    exports: [
        MatDatepickerModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        MatTableModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatSortModule,
        MatTabsModule,
        MatRadioModule,
        MatCardModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatTooltipModule,
        TranslateModule
    ],
})
export class MaterialModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: MaterialModule,
            providers: [],
        };
    }
}
